export const percentage = (total: number, value: number, fixed = 2): string => {
  const min = 0.0;
  if (!total || !value) return min.toFixed(fixed);

  const percent = (value / total) * 100;
  const ret = isNaN(percent) ? min : percent;
  return ret.toFixed(fixed);
};
